import React, { useRef } from "react";
import { DateField, MenuItem, SelectField } from "@curves/ui-base";
import OverviewListSearchBar from "@icoach/components/overviewList/OverviewListSearchBar";
import { parseDate } from "@util/moment";
import { Grid } from "@mui/material";
import { isFunction, refIsRequiredError } from "@util/utils";

const BatchPaymentSearchBar = ({ searchParams, options, resetBatchPayments, onSubmit }) => {
	const { orderTypeOptions } = options || {};
	const typeRef = useRef(null);
	const dateRef = useRef(null);

	const handleSearch = () => {
		if (!refIsRequiredError(typeRef, dateRef)) {
			const params = {
				type: typeRef.current && typeRef.current.getResult(),
				date: parseDate(dateRef.current.getResult(), "YYYY-MM")
			};
			isFunction(onSubmit) && onSubmit(params);
		}
	};

	return (
		<OverviewListSearchBar className={"mb-4"} onSubmit={handleSearch}>
			<Grid container spacing={2}>
				<Grid xs={6} item>
					<SelectField
						label={"項目"}
						ref={typeRef}
						defaultValue={searchParams?.type}
						displayEmpty
						onChange={resetBatchPayments}
						fullWidth
						required
					>
						<MenuItem disabled value=""><em>請選擇</em></MenuItem>
						{Array.isArray(orderTypeOptions) &&
							orderTypeOptions.map(({ text, value }) => (
								<MenuItem key={value} value={value}>
									{text}
								</MenuItem>
							))}
					</SelectField>
				</Grid>
				<Grid xs={6} item>
					<DateField
						ref={dateRef}
						label={"月份"}
						defaultValue={parseDate(searchParams?.date)}
						views={["year", "month"]}
						openTo={"month"}
						format={"YYYY/MM"}
						mask={"____/__"}
						maxDate={parseDate()}
						placeholder={"請選擇月份"}
						onChange={resetBatchPayments}
						fullWidth
						required
					/>
				</Grid>
			</Grid>
		</OverviewListSearchBar>
	);
};

export default BatchPaymentSearchBar;
